import { Search, SectionThemeProvider } from "@trustpilot/businessapp-patternlibrary";
import { useTranslations } from "ilenia";

import { SearchInputWrapper } from "./styled";
import * as Types from "./types";

const SearchInput: React.FC<Types.SearchInput> = ({ type, onSearchValueChange, searchValue }) => {
  const [translations] = useTranslations();

  return (
    <SectionThemeProvider theme="default">
      <SearchInputWrapper className="search-input">
        <Search
          onChange={onSearchValueChange}
          placeholder={translations[`BusinessAccountSelector.search${type}`]}
          size="small"
          value={searchValue}
          onSubmit={null}
        />
      </SearchInputWrapper>
    </SectionThemeProvider>
  );
};

export default SearchInput;
